import { fromTheme } from '@kyruus/ui-theme';
import styled from '@emotion/styled';

export const AlertMarkdownContainer = styled('div')`
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;

  & p {
    margin: 0;
  }

  & a {
    color: ${fromTheme('color_link')};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  & > :first-child {
    margin-top: 0;
  }

  & > :last-child {
    margin-bottom: 0;
  }
`;
